<template>
  <div class="animated fadeIn">
    <Tables
      ref="tableGrid"
      :columns="['NÚMERO', 'DATA DO PEDIDO', $lang.Common.DataTable.Actions]"
      :showReload="true"
      :showTipFooter="false"
      v-on:Load="onLoad"
      v-on:Reload="onLoad"
    >
      <tr v-for="obj in this.objList" v-bind:key="obj.id">
        <TableColumn
          :IsText="true"
          v-on:Edit="onEdit(obj)"
          :status="obj.blocked ? 0 : 1"
          :value="obj.number"
        />
        <TableColumn
          :IsText="true"
          :status="obj.blocked ? 0 : 1"
          :value="obj.createdAt ? formatData(obj.createdAt) : ''"
        />
        <TableColumn
          :IsActionsButtons="true"
          :HasChange="false"
          v-on:Delete="onDelete(obj)"
          :status="obj.status"
        />
      </tr>
    </Tables>
  </div>
</template>
<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import { loading, toast } from '@/shared/utils/UIHelper'

import BlackList from '@/shared/http/repositories/blacklist/blacklist.js'

export default {
  name: 'TipoFinalizacaoValueList',
  mixins: [ActionsForm],
  data () {
    return {
      filters: null,
      data: null,
      form: null
    }
  },
  methods: {
    onLoad () {
      this.onLoadAll()
      this.$eventHub.on('Filter', ({ filters }) => {
        this.filters = filters
        this.$refs.tableGrid.Clear()
        this.$nextTick(() => {
          this.onLoadAll()
        })
      })
    },
    onDelete (obj) {
      loading.push()
      BlackList.Delete(obj.id)

        .then(response => {
          toast.success(this.$lang.Common.Alerts.Success)
          this.onLoadAll()
        })
        .catch(err => {
          this.onException(err)
        }).finally(() => {
          loading.pop()
        })
    },
    onLoadAll () {
      loading.push()
      if (this.filters) {
        BlackList.Search(
          this.filters.data,
          this.$refs.tableGrid.pagingLimit,
          this.$refs.tableGrid.pagingIndex
        )
          .then(response => {
            this.onResultGrid(response)
          })
          .catch(err => {
            this.onException(err)
          })
      } else {
        BlackList.GetAllPaging(
          this.$refs.tableGrid.pagingLimit,
          this.$refs.tableGrid.pagingIndex
        )
          .then(response => {
            this.onResultGrid(response)
          })
          .catch(err => {
            this.onException(err)
          })
      }
    },
    onNew () {
      this.$emit('New')
    },
    onEdit (obj) {
      this.$emit('Edit', obj)
    },
    formatData (data) {
      return this.moment(new Date(data))
        .tz('UTC')
        .format('DD/MM/YYYY')
    },
    formatCondicao (condicao) {
      if (condicao === null) {
        return 'Neutro'
      } else if (condicao === 1) {
        return 'Positivo'
      } else {
        return 'Negativo'
      }
    },
    formatPhone (phone) {
      const cleanPhone = phone.toString().replace(/\D/g, '')
      return cleanPhone.replace(/^(\d{2})(\d{5})(\d{4})$/, '($1) $2-$3')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/blacklist/BlackList/components/list/BlackListList.vue